import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsPercentageOrValueList } from '../../data-provider/select-options';

export const useGetPercentageValueList = () => {
  return useQuery({
    queryKey: ['pre-claims-percentage-or-value-list'],
    queryFn: () => fetchPreClaimsPercentageOrValueList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
